const fileManage = () => import("./views/index.vue");

export default {
  // 文件管理
  path: "/fileManage",
  name: "fileManage",
  component: fileManage,
  meta: {
    root: "/appCenter"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/file/router.js